import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Urls from 'Containers/Urls';
import LogOutModal from 'Redesign_Funnel/components/LogOutModal';
import { isEmbeddedAmazon, isFromAppMobile } from 'Utils/mobile';
import initMaxMindTrackDevices from 'Services/MaxMind/DeviceTracking';
import { useConfig } from 'Contexts/Config';
import LogoGray from './logo-gray.svg';
import {
  FooterContainer, KueskiTermsYear, Wrapper, SignOutButton, SignOut, Terms, CustomLink, Reca,
} from './Footer.styled';

const Footer = ({ reca, showSignOut }) => {
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const { features: DEVICE_TRACKING_ENABLED } = useConfig();

  if (DEVICE_TRACKING_ENABLED) {
    React.useEffect(() => {
      initMaxMindTrackDevices();
    }, []);
  }

  const isSignOutRestricted = isEmbeddedAmazon() || isFromAppMobile();

  return (
    <FooterContainer>
      <Wrapper>
        <SignOut>
          <LogoGray />
          {
            showSignOut && !isSignOutRestricted ? (
              <SignOutButton
                role="presentation"
                onClick={() => setIsLogoutModalOpen(true)}
              >
                Cerrar sesión
              </SignOutButton>
            ) : null
          }
        </SignOut>
        <Terms>
          <KueskiTermsYear>
            {`Kueski © ${new Date().getFullYear()}.`}
          </KueskiTermsYear>
          <CustomLink href={Urls.terms}>
            Términos
          </CustomLink>
          <CustomLink href={Urls.policy}>
            Privacidad
          </CustomLink>
        </Terms>
      </Wrapper>
      {reca?.length > 0 && (
        <Reca>
          {`Registro de Contratos de Adhesión Número: ${reca}. `}
          Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros
          (CONDUSEF).
          Información de contacto CONDUSEF 800 999 8080 y 55 5340 0999
          {' '}
          <CustomLink href="https://www.gob.mx/condusef">
            https://www.gob.mx/condusef
          </CustomLink>
        </Reca>
      )}
      {showSignOut && (
        <LogOutModal open={isLogoutModalOpen} onClose={() => setIsLogoutModalOpen(false)} />)}
    </FooterContainer>
  );
};

Footer.defaultProps = {
  reca: '',
  showSignOut: false,
};

Footer.propTypes = {
  reca: PropTypes.string,
  showSignOut: PropTypes.bool,
};


export default Footer;
